import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FormStepManager from '../../old_Components/PostAJob/FormStepsManager';

const PostJob = () => {
    const location = useLocation();
    const [currentStep, setCurrentStep] = useState('basic');
    useEffect(() => {
        const hash = location.hash.replace('#', '');
        setCurrentStep(hash || 'basic');
    }, [location.hash]);

   

    const nextStep = () => {
        const nextStepIndex = steps.findIndex(step => step.step === currentStep) + 1;
        if (nextStepIndex < steps.length) {
            setCurrentStep(steps[nextStepIndex].step);
        }
    };

    const prevStep = () => {
        const prevStepIndex = steps.findIndex(step => step.step === currentStep) - 1;
        if (prevStepIndex >= 0) {
            setCurrentStep(steps[prevStepIndex].step);
        }
    };

    const steps = [
        { step: 'basic', name: '1. Job Details' },
        { step: 'candidate-requirement', name: '2. Candidate Requirements' },
        { step: 'interview-information', name: '3. Interview Information' },
        { step: 'job-preview', name: '4. Job Preview' },
        { step: 'submit', name: '5. Submit' }
    ];

    return (
        <React.Fragment>
            <section className='setingbg padding-top-100px padding-bottom-60px'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12 text-center'>
                            <h1>Post a New Job</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className='postjobarea'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ul className='postJobTabs'>
                                {steps.map((step, index) => (
                                    <li key={index}>
                                        <span className={currentStep === step.step ? 'active' : ''}>
                                            {currentStep === step.step ? step.name : `Step ${index + 1}`}
                                        </span>
                                        {index < steps.length - 1 && <span className="step-line"></span>}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className='postjobformarea'>
                <div className='container'>
                    <FormStepManager
                        currentStep={currentStep}
                        nextStep={nextStep}
                        prevStep={prevStep}
                    />
                </div>
            </section>
        </React.Fragment>
    );
};

export default PostJob;
